export default __webpack_public_path__ + "./images/bn.99f758d9.png";